import { apiCall, type ApiClientConfig } from "@playbookai/api-clients";
import type { PaginatedResponse, Vsm } from "@playbookai/types";
import type { VsmCatalogItem } from "@playbookai/ui";

export async function listVsmCatalogPage(
  config: ApiClientConfig,
  params: {
    readonly q?: string;
    readonly cursor?: string;
    readonly limit?: number;
    readonly signal?: AbortSignal;
  } = {},
): Promise<{
  readonly items: readonly VsmCatalogItem[];
  readonly nextCursor: string | null;
}> {
  const page = await apiCall<PaginatedResponse<Vsm>>(
    config,
    "GET",
    "/v1/vsms",
    undefined,
    { q: params.q, cursor: params.cursor, limit: params.limit ?? 20 },
    params.signal,
  );
  if (page.hasMore && !page.nextCursor) {
    throw new Error("VSM catalogue returned hasMore without a cursor.");
  }
  return {
    items: page.data.map((vsm) => ({ id: vsm.id, name: vsm.title })),
    nextCursor: page.nextCursor,
  };
}

export async function getVsmCatalogItem(
  config: ApiClientConfig,
  vsmId: string,
): Promise<VsmCatalogItem> {
  const vsm = await apiCall<Vsm>(
    config,
    "GET",
    `/v1/vsms/${encodeURIComponent(vsmId)}`,
  );
  return { id: vsm.id, name: vsm.title };
}
